import { render, staticRenderFns } from "./product-review-carousel.vue?vue&type=template&id=66c03b1f&"
import script from "./product-review-carousel.vue?vue&type=script&lang=js&"
export * from "./product-review-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports